import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Navbar_visitas_empresa_uno } from "../../components/empresa_uno_comp/navbar_visitas";

export const Jhimbo_visitas = () => {
	const [searchParams] = useSearchParams();
	return (
		<>
			<Navbar_visitas_empresa_uno />
		</>
	);
};

export default Jhimbo_visitas;
